import React from 'react';

import CreatePage from './CreatePageV2';

export default function (props) {
  return <CreatePage {...props} />;
}
